// extracted by mini-css-extract-plugin
export default {"zoomModal":"c3-z"};